import styled from "styled-components";

export const StyledContentWizardContainer = styled.div<{ $height: string }>`
  height: ${({ $height }) => $height};
  width: 100%;
  position: relative;
  overflow: hidden;
`;

export const StyledStepWrapper = styled.div`
  width: 100%;
`;
